export function currentRoute(ctx, path) {
  ctx.commit('currentRoute', path);
}